export interface ChartData {
  name: string;
  value: number;
  [key: string]: string | number;
}

export enum Page {
  DASHBOARD = 'dashboard',
  PLAYGROUND = 'playground',
  DB_MONITOR = 'db_monitor',
  USERS = 'users',
  MEMORY = 'memory',
  DAILY_CONDITIONS = 'daily_conditions',
  DOCUMENTS = 'documents',
  TIERS = 'tiers',
  API_KEYS = 'api_keys',
  ADMIN_ACCOUNTS = 'admin_accounts',
  SETTINGS = 'settings',
}

// Tier types are exported from api/tiers.ts
